// extracted by mini-css-extract-plugin
export var displayNone = "_rg-6";
export var imgContainer = "_rg-2";
export var overflowHidden = "_rg-3";
export var productInfoCardButtonContainer = "_rg-5";
export var productTitleText = "_rg-4";
export var rightArrow = "_rg-1";
export var rightArrowContainer = "_rg-0";